import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import useUserType from "../../../hooks/useUserType";
import CustomModal from "../../CustomModal";

const PuzzleGameFinishModal = forwardRef(({ status, onSubmit, onSubmitReset }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isStudent } = useUserType();
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleConfirm = () => {
    onSubmit();
    setIsOpen(false);
  };

  const handleResetgame = () => {
    onSubmitReset();
    setIsOpen(false);
  };

  return (
    <CustomModal
      isOpen={isOpen}
      withCloseButton={false}
      onClose={() => setIsOpen(false)}
      className="max-w-[45rem] rounded-2xl border-8 border-blue-500 bg-[#F1F1F1] shadow-xl"
      contentClassname="px-2 py-6 md:px-10"
    >
      {status === "correct" ? (
        <>
          <h2 className="mb-6 text-center text-3xl font-bold text-blue-900">
            {" "}
            {t("puzzle_game.congratulations")}
          </h2>
          <h4 className="mb-6 text-center text-xl text-blue-900"> {t("puzzle_game.passed")}</h4>
        </>
      ) : (
        <h2 className="mb-3 text-center text-2xl font-semibold text-blue-900">
          {t("puzzle_game.almost_there")}
        </h2>
      )}

      <div className="mt-10 flex items-center justify-between gap-14">
        {status === "correct" ? (
          <button
            onClick={isStudent ? handleConfirm : () => setIsOpen(false)}
            className="wavy-btn relative m-auto w-1/2 rounded-3xl border-4 border-[#ffe4af] bg-orange-500 p-4 text-lg font-semibold text-white transition duration-200"
          >
            {t(isStudent ? "puzzle_game.submit" : "puzzle_game.close")}
          </button>
        ) : (
          <button
            onClick={handleResetgame}
            className="wavy-btn relative m-auto w-1/2 rounded-3xl border-4 border-[#ffe4af] bg-orange-500 p-4 text-lg font-semibold text-white transition duration-200"
          >
            {t("puzzle_game.try_again")}
          </button>
        )}
      </div>
    </CustomModal>
  );
});

export default PuzzleGameFinishModal;
